import { render, staticRenderFns } from "./DiscountSetup.vue?vue&type=template&id=3df76ec1&"
import script from "./DiscountSetup.vue?vue&type=script&lang=js&"
export * from "./DiscountSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports